import Cookies from 'js-cookie';
import qs from 'qs';
import envConfig from '../config';

export const getLoginURLWithRedirection = () => {
  // Check if user is in an agent context based on current path
  const isAgentContext = window.location.pathname.includes('/agent');
  const loginPath = isAgentContext ? '/agent-login' : '/login';

  if (window.location.pathname === loginPath) {
    return loginPath;
  }

  return `${loginPath}?redirectTo=${encodeURIComponent(
    window.location.pathname + window.location.search,
  )}`;
};

export const constructLink = (url: string, params: any) => {
  const isEveryValueEmpty = Object.values(params).every((value) => !value);

  if (isEveryValueEmpty) {
    return url;
  }

  return `${url}?${qs.stringify(params)}`;
};

export const isMalformedURL = (url: string): boolean => {
  try {
    decodeURIComponent(url);
    return false; // The URL is well-formed
  } catch {
    return true; // The URL is malformed
  }
};

export const redirectToBolt = () => {
  const jwtToken = Cookies.get('jwtToken');
  if (jwtToken) {
    window.location.assign(
      `${envConfig.boltBaseUrl}/redirect?jwtToken=${jwtToken}`,
    );
  }
};
